<div class="admin-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px;"
         (click)="minimise = !minimise"></i>
      <i class="fa fa-times" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Stepper (using original CSS classes) -->
  <div class="text-center stepper" [hidden]="minimise">
    @for (item of stepperData; track $index; let i = $index) {
<div
         class="step d-inline-block"
         [style.width.%]="100 / stepperData.length">
      <div class="progress-container">
        @if (i !== stepperData.length - 1) {
<div class="progress">
          <div class="progress-bar"
               [class.progressBarFullWidth]="stepperData[i + 1]?.enabled">
          </div>
        </div>
}
      </div>
      <button class="stepper-1 center-block"
              [class.enabled]="item.enabled"
              [class.current-step]="item.isCurrent"
              (click)="setStep(item.stepNo)">
        {{ item.stepNo }}
      </button>
      <div class="filter-description">
        <h2 class="titleFont">{{ item.stepTitle }}</h2>
      </div>
    </div>
}
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">

    <!-- ========== STEP 1: GENERAL INFORMATION ========== -->
    @if (activeStep === 1) {
<div class="step-content">
      <form novalidate>
        <div class="form-columns">
          <!-- LEFT COLUMN -->
          <div class="form-col-left panel-bro">
            <!-- Client Key (edit only) -->
            @if (mode === 'edit') {
<div class="form-row-item">
              <label class="form-label">Client Key:</label>
              <div class="form-value">{{ client.client_key }}</div>
            </div>
}

            <!-- Client Name -->
            <div class="form-row-item">
              <label class="form-label">Client Name <span class="required">*</span></label>
              <div class="form-field">
                <input type="text" class="form-control"
                       [(ngModel)]="client.client_name" name="client_name"
                       placeholder="enter client name"
                       [class.error-field]="isClientNameDuplicate"
                       (blur)="checkClientName()">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Enter the client name'" [direction]="'right'"></i>
              </div>
              @if (isClientNameDuplicate) {
<div class="text-danger">Client Name already exists.</div>
}
            </div>

            <!-- Client Description -->
            <div class="form-row-item">
              <label class="form-label">Client Description <span class="required">*</span></label>
              <div class="form-field">
                <input type="text" class="form-control"
                       [(ngModel)]="client.client_desc" name="client_desc"
                       placeholder="enter client description">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Enter the client description'" [direction]="'right'"></i>
              </div>
            </div>

            <!-- Client Size -->
            <div class="form-row-item">
              <label class="form-label">Client Size <span class="required">*</span></label>
              <div class="btn-group-toggle">
                @for (size of sizeOptions; track $index) {
<span
                      class="size-btn"
                      [class.active]="client.client_size === size"
                      (click)="client.client_size = size">{{ size }}</span>
}
              </div>
            </div>

            <!-- Is Active -->
            <div class="form-row-item">
              <label class="form-label">Is Active <span class="required">*</span></label>
              <div class="btn-group-toggle">
                <span class="size-btn"
                      [class.active]="client.client_active === '1'"
                      [class.disabled]="isLoggedInClient()"
                      (click)="!isLoggedInClient() && (client.client_active = '1')">Yes</span>
                <span class="size-btn"
                      [class.active]="client.client_active === '0'"
                      [class.disabled]="isLoggedInClient()"
                      (click)="!isLoggedInClient() && (client.client_active = '0')">No</span>
              </div>
            </div>

            <!-- Support Email -->
            <div class="form-row-item">
              <label class="form-label">Support Email</label>
              <div class="form-field">
                <input type="text" class="form-control"
                       [(ngModel)]="supportEmail" name="support_email"
                       placeholder="enter support email">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Support email (without @domain)'" [direction]="'right'"></i>
              </div>
            </div>

            <!-- Engagement ID -->
            <div class="form-row-item">
              <label class="form-label">Engagement ID</label>
              <div class="engagement-list">
                @for (entry of tyEngagementIdsList; track trackByIndex(i); let i = $index) {
<div class="engagement-row">
                  <select class="form-control dropdown engagement-select" [(ngModel)]="entry.taxYear" [name]="'engTy_' + i">
                    <option value="">Select Year</option>
                    @for (ty of taxYears; track $index) {
<option [value]="ty.label">{{ ty.label }}</option>
}
                  </select>
                  <input type="text" class="form-control engagement-input" [(ngModel)]="entry.value" [name]="'engId_' + i" placeholder="Engagement ID">
                  @if (i === 0) {
<i class="fa fa-plus-circle add-engagement" (click)="addEngagementId()"
                     ap-tooltip [tooltipContent]="'Add Engagement ID'" [direction]="'right'"></i>
}
                  @if (i > 0) {
<i class="fa fa-minus-circle remove-engagement color-red" (click)="removeEngagementId(i)"></i>
}
                </div>
}
              </div>
              <i class="glyphicon glyphicon-info-sign info-sign"
                 ap-tooltip [tooltipContent]="'Tax Year = Engagement ID pairs'" [direction]="'right'"></i>
            </div>

            <!-- Engagement Contact -->
            <div class="form-row-item">
              <label class="form-label">Engagement Contact <span class="required">*</span></label>
              <div class="engagement-list">
                @for (contact of engagementContactsList; track trackByIndex(i); let i = $index) {
<div class="engagement-row">
                  <input type="text" class="form-control"
                         [(ngModel)]="engagementContactsList[i]"
                         [name]="'contact_' + i"
                         placeholder="Search Users By Name or SSO">
                  @if (i === 0) {
<i class="fa fa-plus-circle add-engagement" (click)="addEngagementContact()"
                     ap-tooltip [tooltipContent]="'Add Contact'" [direction]="'right'"></i>
}
                  @if (i > 0) {
<i class="fa fa-minus-circle remove-engagement color-red" (click)="removeEngagementContact(i)"></i>
}
                </div>
}
              </div>
              <i class="glyphicon glyphicon-info-sign info-sign"
                 ap-tooltip [tooltipContent]="'Enter engagement contacts'" [direction]="'right'"></i>
            </div>

            <!-- Client Contact -->
            <div class="form-row-item">
              <label class="form-label">Client Contact</label>
              <div class="form-field">
                <input type="text" class="form-control"
                       [(ngModel)]="client.client_contact" name="client_contact"
                       placeholder="enter Client contact email">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Client contact email'" [direction]="'right'"></i>
              </div>
            </div>
          </div>

          <!-- RIGHT COLUMN -->
          <div class="form-col-right">
            <!-- Client Datasource -->
            <div class="form-row-item">
              <label class="form-label">Client Datasource <span class="required">*</span></label>
              <div class="ds-row">
                <span class="ds-badge">GTW</span>
                <input type="text" class="form-control ds-input"
                       [(ngModel)]="clientDatasource" name="clientDatasource"
                       placeholder="4 Chars Only"
                       maxlength="4" minlength="4"
                       style="text-transform: uppercase;"
                       [disabled]="!!client.client_key">
                <span class="ds-badge">{{ getDbEnvDisplay() }}</span>
              </div>
              @if (clientDatasource && clientDatasource.length > 0 && clientDatasource.length < 4) {
<div class="text-danger">
                Only 4 characters allowed
              </div>
}
            </div>

            <!-- Gold Datasource -->
            <div class="form-row-item">
              <label class="form-label">Gold Datasource</label>
              <input type="text" class="form-control"
                     [(ngModel)]="client.client_gold_ds" name="client_gold_ds">
            </div>

            <!-- EO Client ID -->
            <div class="form-row-item">
              <label class="form-label">EO Client ID</label>
              <input type="text" class="form-control"
                     [(ngModel)]="client.eo_native_client_id" name="eo_native_client_id"
                     placeholder="enter EO Client ID">
            </div>

            <!-- Client Logo -->
            <div class="form-row-item">
              <label class="form-label">Client Logo <span class="required">*</span></label>
              <div class="logo-upload-area"
                   [class.drag-over]="dragOver"
                   (dragover)="onLogoDragOver($event)"
                   (dragleave)="onLogoDragLeave($event)"
                   (drop)="onLogoDrop($event)"
                   (click)="triggerLogoUpload()">
                Click Or Drag and drop logo here
              </div>
              <input #logoFileInput type="file" accept="image/*" style="display: none"
                     (change)="onLogoFileSelected($event)">
              @if (client.client_logo) {
<div class="logo-controls">
                <i class="fa fa-minus-circle color-red logo-action"
                   (click)="removeLogo()"
                   ap-tooltip [tooltipContent]="'Remove Logo'" [direction]="'right'"></i>
                <label class="logo-filename" [title]="client.client_logo_file_name">{{ client.client_logo_file_name }}</label>
              </div>
}
              @if (client.client_logo_change_success) {
<div class="logo-warning">
                <label class="label label-warning">The logo will be permanently stored/removed only on save.</label>
              </div>
}
            </div>

            <!-- Logo Previews -->
            <div class="form-row-item preview-row">
              <div class="preview-box preview-small">
                @if (!logoPreviewUrl) {
<span>Preview Small</span>
}
                @if (logoPreviewUrl) {
<img [src]="logoPreviewUrl" style="height: 30px;" alt="" />
}
              </div>
              <div class="preview-box preview-large">
                @if (!logoPreviewUrl) {
<span>Preview Large</span>
}
                @if (logoPreviewUrl) {
<img [src]="logoPreviewUrl" style="height: 58px;" alt="" />
}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
}

    <!-- ========== STEP 2: APPLICATION SETUP ========== -->
    @if (activeStep === 2) {
<div class="step-content application-view">
      @if (setupLoading) {
<div class="loading-indicator">
        <i class="fa fa-spinner fa-spin"></i> Loading application setup...
      </div>
}
      @if (!setupLoading && defaultNodes.length === 0 && clientNodes.length === 0) {
<div class="placeholder-message">
        <i class="fa fa-cogs"></i>
        No application setup data available. Save client in Step 1 first.
      </div>
}

      @if (!setupLoading && (defaultNodes.length > 0 || clientNodes.length > 0)) {
<div class="tree-selector-container">
        <!-- Column Headers -->
        <div class="row tree-header">
          <div class="col-md-6">
            <label class="stack-label">Default Client App stack</label>
          </div>
          <div class="col-md-6">
            <label class="stack-label">{{ client.client_name }} App Stack</label>
            <div class="tree-toolbar">
              <i class="fa fa-check-square-o btn-collapse-all" title="Select ALL"
                 (click)="copyDefaultTree()"></i>
              <i class="fa btn-collapse-all"
                 [ngClass]="{'fa-folder': treeCollapsed, 'fa-folder-open': !treeCollapsed}"
                 title="Collapse/Expand"
                 (click)="toggleCollapseAll()"></i>
              <ap-toggle [(ngModel)]="showPreview" [ariaLabel]="'Preview'"
                         (onChange)="onPreviewToggle($event)">
              </ap-toggle>
              <label class="preview-label">PREVIEW</label>
            </div>
          </div>
        </div>

        <!-- Dual-Panel Tree View -->
        <div class="row treeview-set" [class.half-width]="showPreview">
          <!-- LEFT: Default Nodes -->
          <div class="tree-panel default-panel" [class.full-width]="!showPreview">
            <div class="tree-scroll">
              @for (node of defaultNodes; track trackByChildId($index, node)) {

                @if (defaultChildShowFlags['show_' + node.parent_id] !== false) {
<div class="tree-node"
                     [class.top-level-node]="node.nav_level === '1'"
                    
                     [style.padding-left.px]="node._paddingLeft">
                  @if (node._hasChildren) {
<i class="fa collapse-icon"
                    
                     [ngClass]="{'fa-angle-down': node.showChildren, 'fa-angle-right': !node.showChildren}"
                     (click)="toggleNodeCollapse(node, defaultNodes, defaultChildShowFlags)"></i>
}
                  @if (!node._hasChildren) {
<span class="collapse-icon-placeholder"></span>
}
                  <div class="custom-checkbox"
                       [class.selected]="node.is_selected === 2"
                       (click)="onDefaultNodeClick(node)">
                    @if (node.is_selected === 1) {
<div class="indicator intermitent"></div>
}
                    @if (node.is_selected === 2) {
<i class="fa fa-check check"></i>
}
                  </div>
                  <span class="node-label level-{{node.nav_level}}">{{ node.name }}</span>
                </div>
}
              
}
            </div>
          </div>

          <!-- RIGHT: Client Nodes (Preview) -->
          @if (showPreview && client.client_key > '0' && client.client_key !== '999') {
<div class="tree-panel client-panel">
            <div class="tree-scroll">
              @for (node of clientNodes; track trackByChildId($index, node)) {

                @if (clientChildShowFlags['show_' + node.parent_id] !== false && (node.is_selected === 2 || node.is_selected === 1)) {
<div class="tree-node"
                     [class.top-level-node]="node.nav_level === '1'"
                    
                     [style.padding-left.px]="node._paddingLeft">
                  @if (node._hasChildren) {
<i class="fa collapse-icon"
                    
                     [ngClass]="{'fa-angle-down': node.showChildren, 'fa-angle-right': !node.showChildren}"
                     (click)="toggleNodeCollapse(node, clientNodes, clientChildShowFlags)"></i>
}
                  @if (!node._hasChildren) {
<span class="collapse-icon-placeholder"></span>
}
                  <div class="custom-checkbox selected">
                    <i class="fa fa-check check"></i>
                  </div>
                  @if (!node._editing) {
<span class="node-label level-{{node.nav_level}}">{{ node.name }}</span>
}
                  @if (node._editing) {
<input class="node-editor" [(ngModel)]="node.name"
                         (keyup.enter)="saveNodeEdit(node)" />
}
                  <div class="node-actions">
                    @if (node._editing) {
<i class="fa fa-check node-action-icon css-tooltip"
                       data-tooltip="Save"
                       (click)="saveNodeEdit(node)"></i>
}
                    @if (node._editing) {
<i class="fa fa-close node-action-icon css-tooltip"
                       data-tooltip="Cancel"
                       (click)="cancelNodeEdit(node)"></i>
}
                    @if (node.is_custom === '1') {
<span class="btn-custom">Custom</span>
}
                    @if (!node._editing) {
<i class="fa fa-edit node-edit-icon css-tooltip"
                       data-tooltip="Edit"
                       (click)="startNodeEdit(node)"></i>
}
                  </div>
                </div>
}
              
}
            </div>
          </div>
}
        </div>
      </div>
}
    </div>
}

    <!-- ========== STEP 3: CLIENT LANDING DETAILS ========== -->
    @if (activeStep === 3) {
<div class="step-content">
      <form novalidate>
        <div class="form-columns">
          <div class="form-col-left panel-bro">
            @if (clientLandingDtls.client_dtls_key) {
<div class="form-row-item">
              <label class="form-label">Client Dtls Key</label>
              <div class="form-value">{{ clientLandingDtls.client_dtls_key }}</div>
            </div>
}
            <div class="form-row-item">
              <label class="form-label">Start Date <span class="required">*</span></label>
              <div class="form-field">
                <input type="date" class="form-control" [(ngModel)]="clientLandingDtls.start_date" name="start_date">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Client engagement start date'" [direction]="'right'"></i>
              </div>
            </div>
            <div class="form-row-item">
              <label class="form-label">Ext Filing Date <span class="required">*</span></label>
              <div class="form-field">
                <input type="date" class="form-control" [(ngModel)]="clientLandingDtls.ext_filing_date" name="ext_filing_date">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Extension filing date'" [direction]="'right'"></i>
              </div>
            </div>
            <div class="form-row-item">
              <label class="form-label">Filing Date <span class="required">*</span></label>
              <div class="form-field">
                <input type="date" class="form-control" [(ngModel)]="clientLandingDtls.filing_date" name="filing_date">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Tax return filing date'" [direction]="'right'"></i>
              </div>
            </div>
          </div>

          <div class="form-col-right">
            <div class="form-row-item">
              <label class="form-label">Ext Filed</label>
              <select class="form-control dropdown" [(ngModel)]="clientLandingDtls.ext_filed" name="ext_filed">
                <option value="Y">YES</option>
                <option value="N">NO</option>
              </select>
            </div>
            <div class="form-row-item">
              <label class="form-label">Tax Return Filed 2018</label>
              <select class="form-control dropdown" [(ngModel)]="clientLandingDtls.tax_return_filed_2018" name="tax_return_filed">
                <option value="Y">YES</option>
                <option value="N">NO</option>
              </select>
            </div>
            <div class="form-row-item">
              <label class="form-label">Business Sign Off</label>
              <select class="form-control dropdown" [(ngModel)]="clientLandingDtls.business_sign_off" name="business_sign_off">
                <option value="Y">YES</option>
                <option value="N">NO</option>
              </select>
            </div>
            <div class="form-row-item">
              <label class="form-label">Est Filing Date <span class="required">*</span></label>
              <div class="form-field">
                <input type="date" class="form-control" [(ngModel)]="clientLandingDtls.est_filing_date" name="est_filing_date">
                <i class="glyphicon glyphicon-info-sign info-sign"
                   ap-tooltip [tooltipContent]="'Estimated filing date'" [direction]="'right'"></i>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
}

    <!-- ========== STEP 4: WORKFLOW SETUP ========== -->
    @if (activeStep === 4) {
<div class="step-content">
      <!-- Filter row -->
      <div id="workflow-setup">
        <div class="workflow-filters">
          <div class="wf-filter-group">
            <label>Tax Type:</label>
            <select class="dropdown wf-select" [(ngModel)]="selectedWFType" name="wf_type">
              <option value="">Select</option>
              <optgroup label="Domestic">
                @for (wfType of domesticWorkflowTypes; track $index) {
<option [value]="wfType.wfst_Key">{{ wfType.name }}</option>
}
              </optgroup>
              <optgroup label="Foreign">
                @for (wfType of foreignWorkflowTypes; track $index) {
<option [value]="wfType.wfst_Key">{{ wfType.name }}</option>
}
              </optgroup>
            </select>
          </div>
          <div class="wf-filter-group">
            <label>Tax Year:</label>
            <select class="dropdown wf-select" [(ngModel)]="selectedTaxYear" name="wf_taxyear">
              <option value="">Select</option>
              @for (ty of taxyearsMap; track $index) {
<option [value]="ty">{{ ty }}</option>
}
            </select>
          </div>
          <div class="wf-filter-group">
            <label>Scenario:</label>
            <select class="dropdown wf-select" [(ngModel)]="selectedScenario" name="wf_scenario">
              <option value="">Select</option>
              @for (s of currentScenarios; track $index) {
<option [value]="s.scenario">{{ s.scenario_desc }}</option>
}
            </select>
          </div>
          <button class="btn btn-info btn-sm"
                  [disabled]="!selectedWFType || !selectedTaxYear || !selectedScenario"
                  (click)="refreshWorkflowTree()">Refresh</button>
        </div>
      </div>

      @if (workflowLoading) {
<div class="loading-indicator">
        <i class="fa fa-spinner fa-spin"></i> Loading workflow data...
      </div>
}

      <!-- Placeholder when no tree loaded yet -->
      @if (!workflowLoading && !wfFilterFlag) {
<div class="placeholder-message">
        <i class="fa fa-sitemap"></i>
        Select filters above and click Refresh to load workflow tree.
      </div>
}

      <!-- Workflow Tree Selector (shows after Refresh) -->
      @if (!workflowLoading && wfFilterFlag) {
<div
           class="tree-selector-container workflow-view">
        <!-- Header row -->
        <div class="row tree-header">
          <div class="col-md-6">
            <label class="stack-label">Default Workflow For {{ client.tax_type }}</label>
          </div>
          @if (client.client_key > '0' && client.client_key !== '999') {
<div class="col-md-3">
            <label class="stack-label" style="float: right">{{ client.client_name }} - Workflow</label>
          </div>
}
          <div class="col-md-3">
            <div class="tree-toolbar">
              <i class="fa btn-collapse-all"
                 [ngClass]="{'fa-check-square-o': wfSelectedAll, 'fa-square-o': !wfSelectedAll}"
                 [title]="wfSelectedAll ? 'Select ALL' : 'UnSelect ALL'"
                 (click)="copyDefaultWfTree()"></i>
              <i class="fa btn-collapse-all"
                 [ngClass]="{'fa-folder': wfTreeCollapsed, 'fa-folder-open': !wfTreeCollapsed}"
                 title="Collapse/Expand"
                 (click)="toggleWfCollapseAll()"></i>
              <ap-toggle [(ngModel)]="showWfPreview" [ariaLabel]="'Workflow preview'"
                         (onChange)="onWfPreviewToggle($event)">
              </ap-toggle>
              <label class="preview-label">PREVIEW</label>
              <button class="btn btn-add-workflow" title="Add Category" (click)="openAddCategory()">
                <i class="fa fa-plus-circle"></i> Category
              </button>
              <button class="btn btn-add-workflow" title="Add Step" (click)="openAddStep()">
                <i class="fa fa-plus-circle"></i> Step
              </button>
            </div>
          </div>
        </div>

        <!-- Dual-panel tree view -->
        <div class="row treeview-set" [class.half-width]="showWfPreview">
          <!-- LEFT: Default Workflow Nodes -->
          <div class="tree-panel default-panel" [class.full-width]="!showWfPreview">
            <div class="tree-scroll">
              @for (node of defaultWorkflowNodes; track trackByChildId($index, node)) {

                @if (defaultWfShowFlags['show_' + node.parent_id] !== false) {
<div class="tree-node"
                     [class.top-level-node]="node.nav_level === '1'"
                    
                     [style.padding-left.px]="node._paddingLeft">
                  @if (node._hasChildren) {
<i class="fa collapse-icon"
                    
                     [ngClass]="{'fa-angle-down': node.showChildren, 'fa-angle-right': !node.showChildren}"
                     (click)="toggleNodeCollapse(node, defaultWorkflowNodes, defaultWfShowFlags)"></i>
}
                  @if (!node._hasChildren) {
<span class="collapse-icon-placeholder"></span>
}
                  <div class="custom-checkbox"
                       [class.selected]="node.is_selected === 2"
                       (click)="onDefaultWfNodeClick(node)">
                    @if (node.is_selected === 1) {
<div class="indicator intermitent"></div>
}
                    @if (node.is_selected === 2) {
<i class="fa fa-check check"></i>
}
                  </div>
                  <span class="node-label level-{{node.nav_level}}">{{ node.name }}</span>
                  @if (node.version_number) {
<span class="version-badge">V{{ node.version_number }}</span>
}
                </div>
}
              
}
            </div>
          </div>

          <!-- RIGHT: Client Workflow Nodes (Preview) -->
          @if (showWfPreview && client.client_key > '0' && client.client_key !== '999') {
<div class="tree-panel client-panel"
              >
            <div class="tree-scroll">
              @for (node of clientWorkflowNodes; track trackByChildId($index, node)) {

                @if (clientWfShowFlags['show_' + node.parent_id] !== false && (node.is_selected === 2 || node.is_selected === 1)) {
<div class="tree-node"
                     [class.top-level-node]="node.nav_level === '1'"
                    
                     [style.padding-left.px]="node._paddingLeft">
                  @if (node._hasChildren) {
<i class="fa collapse-icon"
                    
                     [ngClass]="{'fa-angle-down': node.showChildren, 'fa-angle-right': !node.showChildren}"
                     (click)="toggleNodeCollapse(node, clientWorkflowNodes, clientWfShowFlags)"></i>
}
                  @if (!node._hasChildren) {
<span class="collapse-icon-placeholder"></span>
}
                  <div class="custom-checkbox selected">
                    <i class="fa fa-check check"></i>
                  </div>
                  @if (!node._editing) {
<span class="node-label level-{{node.nav_level}}">{{ node.name }}</span>
}
                  @if (node._editing) {
<input class="node-editor" [(ngModel)]="node.name"
                         (keyup.enter)="saveNodeEdit(node)" />
}
                  <div class="node-actions">
                    @if (node._editing) {
<button class="btn btn-info btn-sm btn-edit-workflow"
                           
                            (click)="openEditWorkflow(node)">
                      Edit {{ getWorkflowType(node) }}
                    </button>
}
                    @if (node._editing) {
<i class="fa fa-check node-action-icon css-tooltip"
                       data-tooltip="Save"
                       (click)="saveNodeEdit(node)"></i>
}
                    @if (node._editing) {
<i class="fa fa-close node-action-icon css-tooltip"
                       data-tooltip="Cancel"
                       (click)="cancelNodeEdit(node)"></i>
}
                    @if (node.is_custom === '1') {
<span class="btn-custom">Custom</span>
}
                    @if (node.version_number) {
<span class="version-badge">V{{ node.version_number }}</span>
}
                    @if (!node._editing) {
<i class="fa fa-edit node-edit-icon css-tooltip"
                       data-tooltip="Edit"
                       (click)="startNodeEdit(node)"></i>
}
                  </div>
                </div>
}
              
}
            </div>
          </div>
}
        </div>
      </div>
}
    </div>
}
  </div>

  <!-- Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info" type="button" (click)="save()" [disabled]="saving">
      Save @if (saving) {
<i class="fa fa-spinner fa-spin"></i>
}
    </button>
    <button class="btn btn-warning" type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button class="btn btn-success" type="button" (click)="clearForm()" [disabled]="saving">Clear Form</button>
    @if (mode === 'edit' && client.client_key > '0' && client.client_key !== '999') {
<button
            class="btn btn-danger" type="button" (click)="removeClient()" [disabled]="saving">
      Remove
    </button>
}
  </div>
</div>
